import { render, staticRenderFns } from "./DisableCoupon.vue?vue&type=template&id=db93f4ba"
import script from "./DisableCoupon.vue?vue&type=script&lang=ts"
export * from "./DisableCoupon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports